import React, { useContext, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Login from "./Components/Login/Login";
import ForgetPassword from "./Components/Login/LoginPage/ForgetPassword";

// Dashboard

import Dashboard from "./Components/DashBoard/DashBoard";
import Sidebar from "./Components/Sidebar/Sidebar";
import Header from "./Components/Header/Header";
import AdvanceDashboard from "./Components/DashBoard/AdvanceDashboard/AdvanceDashboard2";
import { Context } from "./utils/context";
import SellerDetails from "./Components/sellerDetails/Table";
import Profile from "./Components/profile/Profile";

import Role from "./Components/EmployeeManagement/Role/Table";
import EmployeeDetails from "./Components/EmployeeManagement/EmployeeDetails/Table";
import Employee from "./Components/EmployeeManagement/Employee/Tables";

import ProductRequests from "./Components/Products/ProductRequests/Table";
import ProductRatings from "./Components/Products/ProductRatings/Tables";
import OfferedProducts from "./Components/Products/Offered_Products/Tables";
import OfferedFoods from "./Components/Foods/Offered_Food/Tables";

// import Orders from "./Components/OrderManagments/Orders/Table";
// import CancelOrders from "./Components/OrderManagments/CancelOrders/Table";
// import OrdersToRefund from "./Components/OrderManagments/OrderToRefund/Table";
// import ReturnOrders from "./Components/OrderManagments/ReturnOrders/Table";
// import SingleOrder from "./Components/OrderManagments/singleOrder/Table";

// Settings

import Homebanner from "./Components/settings/HomeBanner/Tables";
import Storebanner from "./Components/settings/StoreBanner/Tables";
import AdvertisementBanner from "./Components/settings/AdvertismentBanner/Tables";
import FaqCategory from "./Components/settings/FaqCategory/Tables";
import Faqs from "./Components/settings/Faq/Tables";
import AboutUs from "./Components/settings/AboutUs/Tables";
import TermsAndCondition from "./Components/settings/TermsAndConditions/Tables";
import PrivacyPolicy from "./Components/settings/PrivacyPolicy/Tables";
import Help from "./Components/settings/Help/Tables";
import SocialLink from "./Components/settings/SocialLinks/Tables";
import AppSetup from "./Components/settings/AppSetup/Tables";
import AppSetup_edit from "./Components/settings/AppSetup/Edit";
import HomeWatchAndShop from "./Components/settings/HomeWatchAndShop/Tables";

// Categories
import ProductCategory from "./Components/Products/Product_Category/Tables";
import ProductSubCategory from "./Components/Products/Product_Sub_Category/Tables";
import ProductChildCategory from "./Components/Products/Product_Child_Category/Tables";
import Product from "./Components/Products/Product/Table";
import ProductCreate from "./Components/Products/Product/Create/Create";
import ProductEdit from "./Components/Products/Product/Edit/Edit";
import RatingReview from "./Components/Products/ProductRatings/Tables";
import FoodCreate from "./Components/Foods/Foods/Create/Create";
import FoodEdit from "./Components/Foods/Foods/Edit/Edit";
import FoodView from "./Components/Foods/Foods/View/View";

// import FoodAddOnCategory from "./Components/Foods/Food_Add_On_category/Tables";
// import FoodAddOns from "./Components/Foods/Food_Add_On/Tables";

// import StoreCategory from "./Components/Stores/Store_Category/Tables";
// import StoreSubCategory from "./Components/Stores/Store_Sub_Category/Tables";
// import StoreChildCategory from "./Components/Stores/Store_Child_Category/Tables";
// import RestaurantCategory from "./Components/Stores/Restaurant_Category/Tables";
// import Stores from "./Components/Stores/Stores/Table";

// import CategoryRequest from "./Components/Stores/Category_Request/Tables";
// import SubCategoryRequest from "./Components/Stores/Sub_Category_Request/Tables";

import Customers from "./Components/Customers/Customers/Tables";
import Customers_view from "./Components/Customers/Customers/Edit";

import DeliveryBoy from "./Components/DeliveryBoyManagement/DeliveryBoy/Tables";

// import FoodCategory from "./Components/Foods/Food_Category/Tables";
// import FoodSubCategory from "./Components/Foods/Food_Sub_Category/Tables";
// import FoodChildCategory from "./Components/Foods/Food_Child_Category/Tables";
// import Foods from "./Components/Foods/Foods/Table";

// import Transactions from "./Components/reports/Transactions/Tables";

import Brands from "./Components/Masters/Brands/Tables";
import PaymentType from "./Components/Masters/PaymentType/Tables";
import Units from "./Components/Masters/Units/Tables";
import PlanFeature from "./Components/Masters/PlanFeature/Tables";
import Farmer from "./Components/Masters/Farmer/Tables";
import Farmer_edit from "./Components/Masters/Farmer/Edit";
import Farmer_Detail from "./Components/Masters/farmerdetail/Tables";
import Crop from "./Components/Masters/Benefits/Tables";
import Collection_Center from "./Components/Masters/collectioncenter/Tables";
import Review_Reason from "./Components/Masters/reviewreason/Tables";

import Plans from "./Components/Subscriptions/Plans/Tables";
import Appointment from "./Components/Subscriptions/Appointment/Tables";
import Appointment_edit from "./Components/Subscriptions/Appointment/Edit";
import Subscription from "./Components/Subscriptions/Subscriptions/Tables";
import DoctorSubscriptions from "./Components/Subscriptions/DoctorSubscriptions/Tables";
import DoctorSubscriptionsEdit from "./Components/Subscriptions/DoctorSubscriptions/Edit";
import VendorSubscription from "./Components/Subscriptions/VendorSubscriptions/Tables";
import Coupon from "./Components/Masters/Coupons/Tables";
import Coupon_edit from "./Components/Masters/Coupons/Edit";
import MyWallet from "./Components/wallet/wallet/Tables";
import WithdrawRequest from "./Components/wallet/WithdrawRequest/Tables";
import GalleyImages from "./Components/Masters/GalleryImages/Tables";

import CancelReason from "./Components/Masters/CancelReasons/Tables";
import ReturnReason from "./Components/Masters/ReturnReasons/Tables";
import RejectReasons from "./Components/Masters/RejectedReasons/Tables";

// Location
import Country from "./Components/Masters/Country/Tables";
import State from "./Components/Masters/State/Tables";
import City from "./Components/Masters/City/Tables";
import Pincode from "./Components/Masters/Pincode/Tables";
import Area from "./Components/Masters/Area/Tables";

import CountryCode from "./Components/Masters/CountryCodes/Tables";

import { IDS } from "./utils/common";
import PageNotFound from "../src/Components/PageNotFound/PageNotFound";
// import Schedule_Pickup from "./Components/OrderManagments/Orders/Schedule_Pickup/Schedule_Pickup";

// import Product_Orders from "./Components/Orders/product_order/Table";
// import SchedulePickup from "./Components/Orders/product_order/Schedule_Pickup/Schedule_Pickup";
import { getData } from "./utils/api";

import Orders_Table from "./Components/Orders/Orders_Table/Table";
import TimeSlot from "./Components/Masters/TimeSlot/Tables";
// import PurchaseProduct from "./";
import PurchaseProduct from "./Components/PurchaseOrder/PurchaseOrder/Tables";
import PurchaseProduct_edit from "./Components/PurchaseOrder/PurchaseOrder/Edit";
import PurchaseProduct_compare from "./Components/PurchaseOrder/PurchaseOrder/EditReceiving";

import ReceivingOrder from "./Components/PurchaseOrder/ReceivingOrder/Tables";
import ReceivingOrder_edit from "./Components/PurchaseOrder/ReceivingOrder/Edit";

import ProductStock from "./Components/Products/ProductStock/Tables";

import SubscriptionOrder from "./Components/SubscriptionOrder/Order/Tables";

import Supplier from "./Components/PurchaseOrder/Supplier/Tables";
import Plans_edit from "./Components/Subscriptions/Plans/Edit";

import Miscellaneous_Reason from "./Components/Miscellaneous/Miscellaneous_Reason/Tables";
import Miscellaneous_Data from "./Components/Miscellaneous/Miscellaneous_Data/Tables";

import DeliveryRange from "./Components/Masters/DeliveryRange/Edit";
import AboutUsContent from "./Components/AboutUs/AboutUsContent/Tables";
import Founding_Farmers from "./Components/AboutUs/FoundingFarmersContent/Tables";
import Achievement from "./Components/AboutUs/Achievements/Tables";

import Blog from "./Components/Blog/Blog/Tables";

import ContactUsForm from "./Components/ContactUsForm/ContactUsForm/Tables";

import Shape from "./Components/Masters/Shape/Tables";

import Size from "./Components/Masters/Size/Tables";
import Diamond from "./Components/Masters/Diamond/Tables";
import Metal from "./Components/Masters/Metal/Tables";
import Exchange_Rate from "./Components/Masters/Exchange_Rate/Tables";

// Seller

const App = () => {
  const location = useLocation();
  const { isSidebarOpen, isAllow, signin } = useContext(Context);
  const [headerText, setHeaderText] = useState(location.pathname);

  const isLoginPage = location.pathname === "/";
  const isForgetPassword = location.pathname === "/forget-password";

  useEffect(() => {
    setHeaderText(location.pathname);
  });

  const [urls, setUrls] = useState([]);
  useEffect(() => {
    setUrls([
      {
        path: "/",
        element: <Login />,
        status: true,
      },
      {
        path: "/forget-password",
        element: <ForgetPassword />,
        status: true,
      },
      {
        path: "/Header",
        element: <Header />,
        status: true,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
        status: true,
      },
      {
        path: "/advanceDashboard",
        element: <AdvanceDashboard />,
        status: true,
      },

      {
        path: "/employee/role",
        element: <Role />,
        status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/profile",
        element: <Profile />,
        status: true,
      },

      {
        path: "/seller-detail",
        element: <SellerDetails />,
        status: true,
      },
      {
        path: "/employee/employee-detail",
        element: <Employee />,
        status: isAllow?.includes(IDS.User.List),
      },

      // {
      //   path: "/order-managements/orders",
      //   element: <Orders />,
      //   status: true,
      // },
      // {
      //   path: "/order-managements/single-order/:id",
      //   element: <SingleOrder />,
      //   status: true,
      // },
      // {
      //   path: "/order-managements/cancel-orders",
      //   element: <CancelOrders />,
      // },
      // {
      //   path: "/order-managements/order/refund",
      //   element: <OrdersToRefund />,
      //   status: true,
      // },
      // {
      //   path: "/order-managements/order/return",
      //   element: <ReturnOrders />,
      // },

      // {
      //   path: "/order-managements/order/schedule-pickup/:id",
      //   element: <Schedule_Pickup />,
      //   status: true,
      // },
      {
        path: "/product/category",
        element: <ProductCategory />,
        status: isAllow?.includes(IDS.ProductCategory.List),
      },
      {
        path: "/product/sub-category",
        element: <ProductSubCategory />,
        status: isAllow?.includes(IDS.ProductSubCategory.List),
      },
      {
        path: "/product/child-category",
        element: <ProductChildCategory />,
        status: isAllow?.includes(IDS.ProductChildCategory.List),
      },
      {
        path: "/products",
        element: <Product />,
        status: isAllow?.includes(IDS.Product.List),
      },
      {
        path: "/product/create",
        element: <ProductCreate />,
        status: isAllow?.includes(IDS.Product.Add),
      },
      // {
      //   path: "/food/create",
      //   element: <FoodCreate />,
      //   status: isAllow?.includes(IDS.Product.Add),
      // },
      // {
      //   path: "/food/edit/:id",
      //   element: <FoodEdit />,
      //   status: isAllow?.includes(IDS.Product.Edit),
      // },
      // {
      //   path: "/food/view/:id",
      //   element: <FoodView />,
      //   status: isAllow?.includes(IDS.Product.List),
      // },
      // {
      //   path: "/food/add-on-categories",
      //   element: <FoodAddOnCategory />,
      //   status: isAllow?.includes(IDS.FoodAddOnCategory.List),
      // },
      // {
      //   path: "/food/add-ons",
      //   element: <FoodAddOns />,
      //   status: isAllow?.includes(IDS.FoodAddOn.List),
      // },
      {
        path: "/product/edit/:id",
        element: <ProductEdit />,
        status: isAllow?.includes(IDS.Product.Edit),
      },
      {
        path: "/product/rating-reviews",
        element: <RatingReview />,
        status: isAllow?.includes(IDS.RatingReview.Edit),
      },

      // {
      //   path: "/stores",
      //   element: <Stores />,
      //   status: true,
      // },

      // {
      //   path: "/category-request",
      //   element: <CategoryRequest />,
      //   status: true,
      // },

      // {
      //   path: "/sub-category-request",
      //   element: <SubCategoryRequest />,
      //   status: true,
      // },

      // {
      //   path: "/store/category",
      //   element: <StoreCategory />,
      //   status: isAllow?.includes(IDS.StoreCategory.List),
      // },
      // {
      //   path: "/store/sub-category",
      //   element: <StoreSubCategory />,
      //   status: isAllow?.includes(IDS.StoreSubCategory.List),
      // },
      // {
      //   path: "/store/child-category",
      //   element: <StoreChildCategory />,
      //   status: isAllow?.includes(IDS.StoreChildCategory.List),
      // },
      // {
      //   path: "/store/restaurant-category",
      //   element: <RestaurantCategory />,
      //   status: isAllow?.includes(IDS.RestaurantCategory.List),
      // },

      // {
      //   path: "/food/category",
      //   element: <FoodCategory />,
      //   status: isAllow?.includes(IDS.FoodCategory.List),
      // },
      // {
      //   path: "/food/sub-category",
      //   element: <FoodSubCategory />,
      //   status: isAllow?.includes(IDS.FoodSubCategory.List),
      // },
      // {
      //   path: "/food/child-category",
      //   element: <FoodChildCategory />,
      //   status: isAllow?.includes(IDS.FoodChildCategory.List),
      // },
      // {
      //   path: "/Foods/:id",
      //   element: <Foods />,
      //   status: isAllow?.includes(IDS.Product.List),
      // },

      {
        path: "/masters/payment-type",
        element: <PaymentType />,
        status: isAllow?.includes(IDS.PaymentType.List),
      },

      {
        path: "/masters/brands",
        element: <Brands />,
        status: isAllow?.includes(IDS.Brand.List),
      },
      {
        path: "/masters/units",
        element: <Units />,
        status: isAllow?.includes(IDS.Unit.List),
      },

      {
        path: "/masters/plan-feature",
        element: <PlanFeature />,
        status: isAllow?.includes(IDS.PlanFeature.List),
      },
      {
        path: "/masters/farmer",
        element: <Farmer />,
        status: isAllow?.includes(IDS.Farmer.List),
      },
      {
        path: "/masters/farmer/edit/:id",
        element: <Farmer_edit />,
        status: isAllow?.includes(IDS.Farmer.Edit),
      },
      {
        path: "/masters/farmerdetail",
        element: <Farmer_Detail />,
        status: isAllow?.includes(IDS.Farmer_Detail.List),
      },
      {
        path: "/masters/crop",
        element: <Crop />,
        status: isAllow?.includes(IDS.Crop.List),
      },
      {
        path: "/masters/collectioncenter",
        element: <Collection_Center />,
        status: isAllow?.includes(IDS.Collection_Center.List),
      },
      {
        path: "/masters/reviewreason",
        element: <Review_Reason />,
        status: isAllow?.includes(IDS.Review_Reason.List),
      },

      {
        path: "/masters/shape",
        element: <Shape />,
        status: isAllow?.includes(IDS.Review_Reason.List),
      },

      {
        path: "/subscription/plans",
        element: <Plans />,
        status: isAllow?.includes(IDS.Plan.List),
      },
      {
        path: "/subscription/edit/:id",
        element: <Plans_edit />,
        status: isAllow?.includes(IDS.Plan.Edit),
      },
      {
        path: "/subscription/appointment",
        element: <Appointment />,
        status: isAllow?.includes(IDS.Appointment.List),
      },
      {
        path: "/subscription/appointment/edit/:id",
        element: <Appointment_edit />,
        status: isAllow?.includes(IDS.Appointment.Edit),
      },
      {
        path: "/subscriptions",
        element: <Subscription />,
        status: isAllow?.includes(IDS.Subscription.List),
      },
      {
        path: "/doctor-subscriptions",
        element: <DoctorSubscriptions />,
        status: isAllow?.includes(IDS.Subscription.List),
      },
      {
        path: "/doctor-subscriptions/edit/:id",
        element: <DoctorSubscriptionsEdit />,
        status: isAllow?.includes(IDS.Subscription.Edit),
      },

      {
        path: "/vendor-subscriptions",
        element: <VendorSubscription />,
        status: isAllow?.includes(IDS.Subscription.List),
      },
      {
        path: "/settings/location/country",
        element: <Country />,
        status: isAllow?.includes(IDS.Country.List),
      },
      {
        path: "/settings/master/time-slot",
        element: <TimeSlot />,
        status: isAllow?.includes(IDS.TimeSlot.List),
      },
      {
        path: "/settings/location/state",
        element: <State />,
        status: isAllow?.includes(IDS.State.List),
      },
      {
        path: "/settings/location/city",
        element: <City />,
        status: isAllow?.includes(IDS.City.List),
      },
      {
        path: "/settings/location/pincode",
        element: <Pincode />,
        status: isAllow?.includes(IDS.Pincode.List),
      },
      {
        path: "/settings/location/area",
        element: <Area />,
        // status: true,
        status: isAllow?.includes(IDS.Area.List),
      },
      {
        path: "/master/country-code",
        element: <CountryCode />,
        status: isAllow?.includes(IDS.CountryCode.List),
      },
      {
        path: "/settings/home-banner",
        element: <Homebanner />,
        status: isAllow?.includes(IDS.HomeBanner.List),
      },
      {
        path: "/settings/store-banner",
        element: <Storebanner />,
        status: isAllow?.includes(IDS.HomeBanner.List),
      },
      {
        path: "/settings/add-banner",
        element: <AdvertisementBanner />,
        status: isAllow?.includes(IDS.HomeBanner.List),
      },
      {
        path: "/settings/faq-categories",
        element: <FaqCategory />,
        status: isAllow?.includes(IDS.FaqCategory.List),
      },
      {
        path: "/settings/faqs",
        element: <Faqs />,
        status: isAllow?.includes(IDS.Faq.List),
      },
      {
        path: "/settings/about-us",
        element: <AboutUs />,
        status: isAllow?.includes(IDS.AboutUs.List),
      },
      {
        path: "/settings/terms-and-condition",
        element: <TermsAndCondition />,
        status: isAllow?.includes(IDS.TermsAndCondition.List),
      },
      {
        path: "/settings/privacy-policy",
        element: <PrivacyPolicy />,
        status: isAllow?.includes(IDS.PrivacyPolicy.List),
      },
      {
        path: "/settings/help",
        element: <Help />,
        status: isAllow?.includes(IDS.Help.List),
      },
      {
        path: "/settings/social-links",
        element: <SocialLink />,
        status: isAllow?.includes(IDS.SocialLink.List),
      },
      {
        path: "/settings/app-setup",
        element: <AppSetup />,
        status: isAllow?.includes(IDS.AppSetup.List),
      },
      {
        path: "/settings/app-setup/edit/:id",
        element: <AppSetup_edit />,
        status: isAllow?.includes(IDS.AppSetup.List),
      },

      {
        path: "/settings/home-watch-and-shop",
        element: <HomeWatchAndShop />,
        status: isAllow?.includes(IDS.HomeWatchAndShop.List),
      },
      // {
      //   path: "/orders/all-orders",
      //   element: <Product_Orders />,
      //   status: isAllow?.includes(IDS.Order.List),
      // },
      {
        path: "/orders/all-orders",
        element: <Orders_Table />,
        status: isAllow?.includes(IDS.Order.List),
      },
      // {
      //   path: "/orders/schedule-pickup/:id",
      //   element: <SchedulePickup />,
      //   status: isAllow?.includes(IDS.Order.List),
      // },
      {
        path: "/product/ratings/:id",
        element: <ProductRatings />,
        status: isAllow?.includes(IDS.RatingReview.List),
      },
      {
        path: "/customers",
        element: <Customers />,
        status: isAllow?.includes(IDS.Customer.List),
      },

      {
        path: "/customers/view/:id",
        element: <Customers_view />,
        status: isAllow?.includes(IDS.Customer.List),
      },

      {
        path: "/delivery-boy",
        element: <DeliveryBoy />,
        status: isAllow?.includes(IDS.User.List),
      },
      {
        path: "/aboutus/about-us-content",
        element: <AboutUsContent />,
        status: isAllow?.includes(IDS.Area.List),
      },
      {
        path: "/coupons/coupon",
        element: <Coupon />,
        status: isAllow?.includes(IDS.Coupon.List),
      },
      {
        path: "/coupons/edit/:id",
        element: <Coupon_edit />,
        status: isAllow?.includes(IDS.Coupon.Edit),
      },

      {
        path: "/my-wallet",
        element: <MyWallet />,
        status: isAllow?.includes(IDS.Wallet.List),
      },
      {
        path: "/wallet/withdraw-request",
        element: <WithdrawRequest />,
        status: isAllow?.includes(IDS.Wallet.List),
      },
      {
        path: "/image-gallery",
        element: <GalleyImages />,
        status: isAllow?.includes(IDS.GalleryImage.List),
      },

      {
        path: "/master/cancel-reason",
        element: <CancelReason />,
        status: isAllow?.includes(IDS.CancelReason.List),
      },
      {
        path: "/master/reject-reason",
        element: <RejectReasons />,
        status: isAllow?.includes(IDS.RejectReasons.List),
      },
      {
        path: "/master/return-reason",
        element: <ReturnReason />,
        status: isAllow?.includes(IDS.ReturnReason.List),
      },
      {
        path: "/product/offered-products",
        element: <OfferedProducts />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/foods/offered-foods",
        element: <OfferedFoods />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/purchase-product/purchase-product",
        element: <PurchaseProduct />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },

      {
        path: "/purchase-product/edit/:id",
        element: <PurchaseProduct_edit />,
        status: isAllow?.includes(IDS.OfferedProduct.Edit),
      },

      {
        path: "/purchase-product/compare/:id",
        element: <PurchaseProduct_compare />,
        status: isAllow?.includes(IDS.OfferedProduct.Edit),
      },

      {
        path: "/purchase-product/receiving-order",
        element: <ReceivingOrder />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },

      {
        path: "/purchase-product/supplier",
        element: <Supplier />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },

      {
        path: "/purchase-product/receiving-order/edit/:id",
        element: <ReceivingOrder_edit />,
        status: isAllow?.includes(IDS.OfferedProduct.Edit),
      },

      {
        path: "/product/product-stock",
        element: <ProductStock />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/subscription-order/order",
        element: <SubscriptionOrder />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },

      {
        path: "/miscellaneous/reason",
        element: <Miscellaneous_Reason />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/miscellaneous/data",
        element: <Miscellaneous_Data />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },

      {
        path: "/aboutus/founding-farmers",
        element: <Founding_Farmers />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/aboutus/achievement",
        element: <Achievement />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/blog",
        element: <Blog />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/contact-us-form",
        element: <ContactUsForm />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },

      {
        path: "/master/delivery-range",
        element: <DeliveryRange />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },

      {
        path: "/masters/size",
        element: <Size />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/masters/diamond",
        element: <Diamond />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },

      {
        path: "/masters/metal",
        element: <Metal />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
      {
        path: "/masters/exchange-rate",
        element: <Exchange_Rate />,
        status: isAllow?.includes(IDS.OfferedProduct.List),
      },
    ]);
  }, [isAllow]);

  const [isLaptopView, setIsLaptopView] = useState(window.innerWidth > 991);
  useEffect(() => {
    const handleResize = () => {
      setIsLaptopView(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // if (!isLaptopView) {
  //   return (
  //     <div style={{ padding: "2rem", textAlign: "center" }}>
  //       <h2>Kindly open admin panel in laptop view</h2>
  //     </div>
  //   );
  // }

  return (
    <div
      className={`main ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
      {isLoginPage && !signin ? (
        <Login />
      ) : isForgetPassword && !signin ? (
        <ForgetPassword />
      ) : (
        <div className=" row me-0 ms-0">
          <div
            className={`${
              isSidebarOpen
                ? "sidebarHeadopen col-xl-2 col-lg-2 col-md-1 col-1  p-0"
                : "scale-in-hor-left sidebarHeadClose col-xl-1 col-md-1 col-1  p-0"
            }  pe-0`}>
            <div
              className={`${
                isSidebarOpen
                  ? "sidebarHeadopen "
                  : "scale-in-hor-left sidebarHeadClose"
              }  pe-0`}>
              <Sidebar />
            </div>
          </div>

          <div
            className={`${
              isSidebarOpen
                ? "dashboradopen col-xl-10 col-lg-10 col-md-11 col-11 p-0"
                : "scale-in-hor-right dashboradopen  col-xl-11 col-md-11 col-11 p-0"
            }  ps-0`}>
            <div
              className={`${
                isSidebarOpen
                  ? "dashboradopen"
                  : "scale-in-hor-right dashboradopen"
              }  ps-0`}>
              <div className="allRoutesMain tab-radio">
                <Routes>
                  {urls?.map(
                    (url) =>
                      url.status && (
                        <Route path={url.path} element={url.element} />
                      ),
                  )}
                  <Route path="*" element={<PageNotFound />} />
                </Routes>
              </div>
              {/* <Home /> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
